var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('v-main',{class:_vm.getClass},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }